import styled, { keyframes } from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import Button from 'builder/components/Button'
import Media from 'builder/styles/media'
import Typography, { FontWeights } from 'builder/styles/typography'
import { Icon20, Icon24 } from 'builder/components/Icon'

export const GenerateButton = styled(Button)`
  margin-left: 30px;
  padding: 8px 12px;
  gap: 4px;
  background: ${Colors.Blue50};
  color: ${Colors.White};
  ${Typography.Body};
  ${FontWeights.Medium};

  &:hover {
    background-color: ${Colors.Blue60};
  }

  @media (max-width: 1550px) {
    margin-left: 10px;
  }

  ${Media.Tablet`
    margin-left: 30px;
  `}

  ${Media.Phone`
    ${Typography.Caption};
    padding: 7px;
    width: 100%;
    margin-top: 10px;
    height: 34px;
    margin-left: 0;
  `}
`

const Banner = styled.div<{ $isError?: boolean }>`
  background-color: ${props => (props.$isError ? Colors.Red10 : Colors.Blue10)};
  display: flex;
  flex-direction: row;
  border-radius: 8px;
  margin-bottom: 40px;
  align-items: center;
  justify-content: flex-end;
  position: relative;

  ${Media.Phone`
    flex-direction: column;
    align-items: start;
    margin-bottom: ${Spacing.M};
  `}

  &:hover ${GenerateButton} {
    background-color: ${Colors.Blue60};
  }

  ${props =>
    !props.$isError &&
    `
      &:hover {
        background: linear-gradient(0deg,
        rgba(195, 229, 254, 0.5) 0%, rgba(195, 229, 254, 0.5) 100%), #fff;
      }
    `}
`

export const Content = styled.p<{
  $addMarginRight?: boolean
  $useMaxWidth?: boolean
  $isError?: boolean
}>`
  color: ${props => (props.$isError ? Colors.Red50 : Colors.Blue80)};
  ${Typography.Tiny};
  ${props => props.$useMaxWidth && 'max-width: 133px;'}
  ${props => props.$addMarginRight && 'margin-right: 20px;'}
  ${props => props.$isError && FontWeights.Medium}

  ${Media.Phone`
    max-width: unset;
  `}
`

export const BannerImage = styled.img`
  width: 47px;
  transition: opacity 0.1s ease-out;

  ${Media.Phone`
    width: 46px;
  `}
`

export const ImageContainer = styled.div`
  display: flex;
  flex: 0 0 auto;
  position: relative;
  margin-right: auto;
`

export const ImageDefault = styled(BannerImage)`
  opacity: 1;
  width: 59px;
  height: 32px;

  ${Media.Hover`
    ${Banner}:hover & {
      opacity: 0;
    }
  `}

  ${Media.Phone`
    opacity: 1;
  `}
`

export const ImageDefaultNoHover = styled(BannerImage)`
  width: 59px;
  height: 32px;
`

export const ImageHovered = styled(BannerImage)`
  opacity: 0;
  position: absolute;
  left: 0;
  top: 0;
  width: 84px;
  height: 32px;

  ${Media.Hover`
    ${Banner}:hover & {
      opacity: 1;
    }
  `}
`

export const BadgeBanner = styled(Banner)<{ $hide?: boolean; $reducePadding?: boolean }>`
  padding: 16px 12px 16px 16px;
  flex: 1;
  ${props => props.$hide && 'display: none;'}

  ${props =>
    props.$reducePadding &&
    `
    @media (max-width: 1550px) {
      padding-left: 4px;
      padding-right: 8px;
    }
  `}

  ${Media.Tablet`
    padding: 16px 12px 16px 16px;
  `}
`

export const BadgeInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
`

const rotation = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`

export const Spinner = styled(Icon24.Spinner)`
  color: ${Colors.Blue50};
  animation: ${rotation} 0.5s infinite linear;
  margin-right: 4px;
  margin-left: auto;
`

export const RightArrow = styled(Icon24.ChevronRight)`
  color: ${Colors.Blue50};
  cursor: pointer;
  margin-left: auto;
`

export const Close = styled(Icon24.Close)`
  color: ${Colors.Neutral100};
  cursor: pointer;
  margin-left: auto;
`

export const ReviewAvatar = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 100%;
`

export const StarContainer = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 100%;
  background-color: ${Colors.Indigo80};
  border: 3px solid white;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
  margin-left: -10px;
  margin-top: auto;
  margin-right: 13px;
`

export const Star = styled(Icon20.Star)`
  color: white;
`

export const ErrorContainer = styled.div`
  background-color: ${Colors.Red50};
  border-radius: 100%;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 12px;
`

export const ErrorClose = styled(Icon20.Close)`
  color: white;
`
